import script from "./AssetLink.vue?vue&type=script&lang=ts"
export * from "./AssetLink.vue?vue&type=script&lang=ts"

import "./AssetLink.vue?vue&type=style&index=0&id=717e53ad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717e53ad"]])

export default __exports__